"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRestInterface = createRestInterface;
exports["default"] = void 0;

var _url = _interopRequireDefault(require("url"));

var _formData = _interopRequireDefault(require("form-data"));

var _api = require("../../api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RestClient =
/*#__PURE__*/
function () {
  function RestClient() {
    var networkInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RestClient);

    if (networkInterface.headers) {
      this.headers = networkInterface.headers;
    }

    if (networkInterface.baseUrl) {
      this.baseUrl = networkInterface.baseUrl;
    }
  }

  _createClass(RestClient, [{
    key: "get",
    value: function get(url, timeout) {
      return this.timeout(fetch(this.requestUrl(url), {
        method: 'GET',
        credentials: 'same-origin',
        headers: this.headers
      }), timeout).then(this.handleResponse);
    }
  }, {
    key: "post",
    value: function post(url, body, timeout) {
      if (!!body) this.setContentType(body);
      return this.timeout(fetch(this.requestUrl(url), {
        method: 'POST',
        credentials: 'same-origin',
        headers: this.headers,
        body: this.validateBody(body)
      }), timeout).then(this.handleResponse);
    }
  }, {
    key: "patch",
    value: function patch(url, body, timeout) {
      if (!!body) this.setContentType(body);
      return this.timeout(fetch(this.requestUrl(url), {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: this.headers,
        body: this.validateBody(body)
      }), timeout).then(this.handleResponse);
    }
  }, {
    key: "delete",
    value: function _delete(url, timeout) {
      return this.timeout(fetch(this.requestUrl(url), {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: this.headers
      }), timeout).then(this.handleResponse);
    }
  }, {
    key: "timeout",
    value: function timeout(promise) {
      var msec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject({
            message: i18n.t('Request Timeout'),
            response: {
              status: 408,
              data: {
                errors: []
              }
            }
          });
        }, msec);
        promise.then(resolve, reject);
      });
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      var responseText = response.text();
      var responseHeader = {}; // 4xx系, 5xx系エラーのときには response.ok==false になる

      if (!response.ok) {
        if (response.status === 503) {// onMaintenance
        }

        return responseText.then(function (text) {
          var error = JSON.parse(text);
          return Promise.reject({
            message: error.message,
            response: {
              status: response.status,
              data: {
                errors: error.errors
              }
            }
          });
        });
      }

      if (response.headers.has('X-Custom-Token')) {
        responseHeader['X-Custom-Token'] = response.headers.get('X-Custom-Token');
      }

      return responseText.then(function (text) {
        return Promise.resolve({
          data: !text || text.length === 0 ? {} : JSON.parse(text),
          status: parseInt(response.status),
          headers: responseHeader
        });
      });
    }
  }, {
    key: "isFormData",
    value: function isFormData(body) {
      return body.constructor.name === 'FormData' ? true : false;
    }
  }, {
    key: "validateBody",
    value: function validateBody(body) {
      if (!!body) {
        return this.isFormData(body) ? body : JSON.stringify(body);
      }
    }
  }, {
    key: "setContentType",
    value: function setContentType(body) {
      if (!this.isFormData(body)) this.headers['Content-Type'] = 'application/json';
    }
  }, {
    key: "requestUrl",
    value: function requestUrl(url) {
      var host = _url["default"].parse(url).host;

      return !!host ? url : "".concat(this.baseUrl, "/").concat(url);
    }
  }]);

  return RestClient;
}();

exports["default"] = RestClient;

function createRestInterface() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.createDefaultInterface)('REST', options);
}